export const API_TIMEOUT = 30000;

export const API_ACCEPT = 'application/json';
export const CONTENT_TYPE = 'application/json';
